import React, { useEffect, useState } from "react";
// styled components
import { Row, Col, Empty, Table } from "antd";
import { Dropdown, Icon } from "semantic-ui-react";
// data select
import { cantidadRegistros } from "../../../../utils/dataSelectOptions";
// icons
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { PostulacionModel } from "../../../../models/PostulacionesModel/postulacion.model";
// api services
import apiParticipantes from "../../../../api/Participantes/api-participantes";
import { ReactComponent as IconFlechareg } from "../../../../assets/flecha_reg.svg";

interface IProps {
  postulacion: PostulacionModel;
}

export const ParticipantesPostulacion: React.FC<IProps> = (props: IProps) => {
  // state
  const [participantes, setParticipantes] = useState<any>([]);
  const [cantidadpáginas, setCantidadPáginas] = useState<number>(10);
  const [totalregistros, setTotalRegistros] = useState<number>(0);
  //   functions
  useEffect(() => {
    let mounted = true;
    if(mounted) {
      consultarParticipantes();
    }
    return () => {
      mounted = false
    }
  }, []);
  const consultarParticipantes = async () => {
    try {
      let { data } = await apiParticipantes.consultarParticipantes(props.postulacion.id_postulacion);
      console.log(data)
      setTotalRegistros(data.length);
      return setParticipantes(data);
      
    } catch (error) {
      console.log(error)
    }
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    return setCantidadPáginas(value);
  };
  //   pagination table
  function itemRenderTable(current: any, type: any, originalElement: any) {
    if (type === "prev") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          <LeftOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingRight: "2px" }} />
          Ant.
        </span>
      );
    }
    if (type === "next") {
      return (
        <span className="border-ant-prev-table font-size-10px">
          Sig.
          <RightOutlined className="font-color-051923bf" style={{ display: "inline-flex", paddingLeft: "2px" }} />
        </span>
      );
    }
    return originalElement;
  }
  // columns
  const columns = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, datos2: any, index: number) => {
        return (
          <>
            <span>{index + 1}</span>
          </>
        );
      },
    },
    {
      title: "Nombres y apellidos",
      width: 120,
      render: (datos: any, record: any, index: number) => (
        <div className="row">
          <div className="col-12"
           
          >{`${datos.primer_nombre} ${datos.segundo_nombre} ${datos.primer_apellido} ${datos.segundo_apellido}`}</div>
        </div>
      ),
    },
    {
      title: "Número de documento",
      width: 120,
      render: (datos: any, record: any, index: number) => (
        <div className="row">
          <div className="col-12">{datos.participante_id}</div>
        </div>
      ),
    },
  ];
  return (
    <div>
	
	<div className="row" style={{ padding: "16px" }}>
               <div className="col-12 col-md-6 pb-2 font-size-14px font-family-Montserrat-SemiBold">
                  Lista de participantes
               </div>
               <div className="col-12 col-md-6">
                  <div className="row g-2">
                     <div className="col-10 col-md-10  col-xl-10 col-xxl-11  d-flex justify-content-end align-content-center">
                        <span className="pe-4 col d-flex justify-content-md-end font-size-12px">
                        Total : <span className="font-color-F28C02">{totalregistros}</span>
                        </span>  
                        <span className="d-flex flex-nowrap pt-1 justify-content-end font-family-Montserrat-Regular font-size-9px font-color-7E7E7E">
                        Registros por página
                        </span>
                     </div>
                     <div className="col-2 col-md-2 col-xl-2 col-xxl-1 justify-content-between">
                        <Dropdown
                        fluid
                        className="select-registros-adminconvocatoria no-margin"
                        defaultValue={cantidadpáginas}
                        options={cantidadRegistros}
                        icon={<IconFlechareg/>
                    }
                        onChange={(e, { value }) => cambiarCantidadPaginas(e, value)}
                        />
                     </div>
                  </div>
               </div>
            </div>
      <div className="row">
        <div className="col-12" style={{ padding: "16px" }}>
          <Table
            style={{ borderTop: "1px solid #C4C4C4" }}
            locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
            pagination={{
              position: ["bottomRight"],
              itemRender: itemRenderTable,
              pageSize: cantidadpáginas,
              hideOnSinglePage: true,
            }}
            dataSource={participantes}
            columns={columns}
            size="small"
            bordered={false}
          />
        </div>
      </div>
    </div>
  );
};
